// extracted by mini-css-extract-plugin
export var dark = "container-module--dark--EjVFv";
export var narrow = "container-module--narrow--dlioA";
export var narrower = "container-module--narrower--Y9lQs";
export var root = "container-module--root--JHM7J";
export var split = "container-module--split--qfvv5";